import { html } from 'lit';

export function themeCircle() {
  return html`<div class="progress__item"></div>`;
}
